import { UpgradeOffer } from '@pubstack/common/src/upgrade'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'

/** The headline of an upgrade page: what the offer lets you do, not what you are missing. */
export const UPGRADE_OFFER_TITLE: Record<UpgradeOffer, string> = {
  one: 'Deploy your header bidding with One',
  node: 'Run your auctions server-side with Node',
}

/**
 * The One and Node copy, defined here and read by `productPitch.ts` for the whole-catalogue page.
 *
 * One product says one thing wherever it is pitched. The two surfaces differ in framing, not in claims:
 * this one stands in for a tab the scope cannot open, so it is headed by a verb, while the catalogue page
 * heads its card with a tagline. Everything below the headline is the same words in both.
 */
export const UPGRADE_OFFER_PITCH: Record<UpgradeOffer, string> = {
  one: 'Build, deploy and optimise your client- and server-side header bidding from a single no-code platform. Ad units, bidders, floors and stacks live here and ship to your medias on your schedule.',
  node: 'Run your Prebid auctions on Pubstack’s Prebid Server. Server-side, in-app and AMP inventory is declared once here and served without a client-side wrapper to maintain.',
}

export const UPGRADE_OFFER_BENEFITS: Record<UpgradeOffer, string[]> = {
  one: [
    'Deploy a stack per media in one click, with no engineering ticket.',
    'Activate any of 100+ pre-integrated partners in minutes.',
    'A/B test bidders, formats and layouts, then keep what wins.',
  ],
  node: ['Cut page latency by moving the auction off the browser.', 'Switch a bidder from client to server-side and compare the two.', 'Monetise in-app and AMP from the same ad unit list.'],
}

/**
 * The ask on an upgrade surface, naming what the conversation is about.
 *
 * The sidebar footer carries a permanent "Contact us" that opens this same HubSpot form, so a pitch
 * whose button said "Contact us" put the same two words twice on one screen and made the reader work
 * out that only one of them knew which product they had just been shown.
 */
export const UPGRADE_OFFER_CTA: Record<UpgradeOffer, string> = {
  one: 'Talk to us about One',
  node: 'Talk to us about Node',
}

export const upgradeRequestTrackingLabel = (offer: UpgradeOffer): TrackingLabel => `common-upgrade-${offer}-request`
